import { InsuredLegalRepre } from "./repre-data-types";

export const emptyLegalGuardianErrors = {
  name: "",
  lastname1: "",
  lastname2: "",
  nationality: "",
  birthDate: "",
  docType: "",
  docNumber: "",
  passportDate: "",
  relationship: "",
  email: "",
  mobilePhone: "",
  landlinePhone: "",
  address: {
    street: "",
    streetType: "",
    streetNumber: "",
    stairs: "",
    floorNumber: "",
    door: "",
    province: "",
    city: "",
    postalCode: "",
  },
};

export const emptyLegalGuardianData: InsuredLegalRepre = {
  name: "",
  lastname1: "",
  lastname2: "",
  nationality: "",
  birthDate: "",
  docType: "",
  docNumber: "",
  passportDate: "",
  relationship: "",
  email: "",
  mobilePhone: "",
  landlinePhone: "",
  address: {
    address: { value: "", code: "", label: "" },
    wayType: "",
    number: "",
    postalCode: "",
    province: { value: "", code: "", label: "" },
    town: { value: "", code: "", label: "" },
    door: "",
    floor: "",
    portal: "",
    stairs: "",
    sameAsTaker: false,
    normalizaDireciones: "S",
  },
};
